const userTypes = Object.freeze({
  NONE: 0,
  REQUESTER: 1,
  APPROVER: 2,
  UPLOADER: 4,
  ADMIN: 8,
});

export default userTypes;
